<template>
  <LoadingScreen />
</template>
<script>
import { mapState, mapActions } from 'vuex'
import LoadingScreen from '@/components-v2/common/loading/LoadingScreen.vue'
import config from '@/config'
import utils from '@/util'
import SlideApi from '@/api/slide'

export default {
  components: {
    LoadingScreen,
  },
  data() {
    return {
      isLoading: null,
    }
  },
  computed: {
    ...mapState({
    }),
  },
  async created() {
    await this.updatePresentationActiveSlide()
  },
  methods: {
    ...mapActions([
      'getCurrentUserAction',
    ]),
    async updatePresentationActiveSlide() {
      try {
        const googleSlideId = utils.getParamValue('googleSlideId')
        const presentationId = utils.getParamValue('presentationId')
        const uniqueAccessCode = utils.getParamValue('uniqueAccessCode')
        const resp = await SlideApi.getSlideByGoogle(googleSlideId)
        const payloadSlide = {
          activeSlide: resp.body.id,
          accessCode: uniqueAccessCode,
          timestamp: new Date().getTime(),
        }
        await this.$http.put(config.api.updateNextSlide + presentationId, payloadSlide)
        const link = `${config.presenterDomain}/presentation/${presentationId}?presenting=true`
        window.location.href = link
      } catch {
        // do nothing
      }
    },
  },
}
</script>
<style scoped lang="scss"></style>
